import { render, staticRenderFns } from "./DamTable.vue?vue&type=template&id=ebefb80c&scoped=true"
import script from "./DamTable.vue?vue&type=script&lang=ts"
export * from "./DamTable.vue?vue&type=script&lang=ts"
import style0 from "./DamTable.vue?vue&type=style&index=0&id=ebefb80c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebefb80c",
  null
  
)

export default component.exports